import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
// import publicIp from 'public-ip'
// import AuthenticationService from '../components/Security/AuthenticationService'

export const checkDevice = (duid, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.checkDevice + '?duid=' + duid
    api.getData(url, data => {
      callback(data)
    })
  }
}

export const unBind = (duid, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    api.getPublicIp().then(ip => {
      let absoluteUrl = Config.apiBaseUrl + CommonConstants.apiUrls.UnBindRemoteDeviceWeb + '?oDeviceID=' + duid + '&sRequestorHost=' + ip
      api.getData(absoluteUrl, data => {
        callback(data)
      })
    })
  }
}

export const unBindEmail = (duid, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.unBindMail
    let emailObject = {
      duid: duid
    }
    api.postData(url, emailObject, data => {
      callback(data)
    }, error => {
      console.log(error)
    })
  }
}

export const reboot = (duid, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    let absoluteUrl = Config.apiBaseUrl + CommonConstants.apiUrls.RestartDevice + '?oDeviceID=' + duid
    api.getData(absoluteUrl, data => {
      callback(data)
    })
  }
}

export const reConnect = (duid, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    let absoluteUrl = Config.apiBaseUrl + CommonConstants.apiUrls.ForceReconnect + '?oDeviceID=' + duid
    api.getData(absoluteUrl, data => {
      callback(data)
    })
  }
}

export const upgrade = (duid, callback) => {
  const params = new URLSearchParams(window.location.search)
  var subVersion = params.get('vz') ? params.get('vz') : null
  return (dispatch, getState) => {
    const api = new Api()
    let absoluteUrl = Config.apiBaseUrl + CommonConstants.apiUrls.DownloadNewImage + `?oDeviceID=${duid}&sVersion=${subVersion}&sRunTime=&sSettingsVersion=GNRC&sUpgradeType=patch`
    api.getData(absoluteUrl, data => {
      callback(data)
    })
  }
}

export const connectRemote = (duid, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    api.getPublicIp().then(ip => {
      let absoluteUrl = Config.apiBaseUrl + CommonConstants.apiUrls.BindRemoteDeviceWeb + '?oDeviceID=' + duid + '&sRequestorHost=' + ip
      api.getData(absoluteUrl, data => {
        callback(data)
      })
    })
  }
}

export const autoRegisterByEmailAddress = (emailaddress, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    let absoluteUrl = CommonConstants.Api.Facade.RemoteExecution.AutoRegisterByEmailAddress + '?sEmailAddress=' + emailaddress
    api.RemoteExecutionServiceCall(absoluteUrl, data => {
      callback(data)
    })
  }
}

export const unRegisterSystem = (duid, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    let absoluteUrl = CommonConstants.Api.Facade.RemoteExecution.Unregister + '?oDeviceID=' + duid
    api.RemoteExecutionServiceCall(absoluteUrl, data => {
      callback(data)
    })
  }
}

export const unRegisterSystemSetSettings = (duid, CIBXML, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    let absoluteUrl = CommonConstants.Api.Facade.RemoteExecution.SetSettings + '?oDeviceID=' + duid + '&?sSettingsXml' + CIBXML
    api.RemoteExecutionServiceCall(absoluteUrl, data => {
      callback(data)
    })
  }
}

// Remove Zoom Device
export const unRegisterZoomSystem = (input, callback) => {
  return (dispatch, getState) => {
    const api = new Api()
    let absoluteUrl = CommonConstants.Api.Facade.RemoteExecution.RemoveDeviceFromStore + '?deviceID=' + input.deviceID + '&deviceUID=' + input.deviceUID + '&deviceVersion=' + input.deviceVersion + '&storeID=' + input.storeID + '&storeUID=' + input.storeUID
    api.RemoteExecutionServiceCall(absoluteUrl, data => {
      callback(data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/actions.js